<template>
<bottom-sheet @close="closeMenu">
  <div class="padding-ml" style="text-align: right">
    <img class="close-btn margin-bottom-l" :src="require(`@/assets/icons/close-thin.svg`)" @click="closeMenu">
    <div class="ri-body">{{ selectedVariantValues.secondaryTitle }}</div>
    <div class="ri-large-headline margin-top-m" style="font-size: 30px;font-weight: normal">
      <span>{{selectedVariantValues.title}}</span><span class="main-discount ri-font-weight-bold">{{ selectedVariantValues.mainDiscount }} ₪</span>
    </div>
    <div class="ri-body margin-top-xl">{{ selectedVariantValues.currentInterestText }}</div>
    <div class="margin-top-xs">
      <span class="amount">{{ selectedVariantValues.currentInterestPayments }}</span>
      <span class="ri-body">₪</span>
    </div>
    <separator class="margin-top-m" />
    <div class="ri-body margin-top-sm">{{ selectedVariantValues.alternativeInterestText }}</div>
    <div class="margin-top-xs">
      <span class=" amount">{{ selectedVariantValues.alternativeInterestPayment }}</span>
      <span class="ri-body">₪</span>
    </div>
    <separator class="margin-top-m" />
    <div class="ri-body margin-top-xs">{{ selectedVariantValues.discountText }}</div>
    <div class="main-discount margin-top-s">
      <span class="amount ri-font-weight-bold">{{ selectedVariantValues.mainDiscount }}</span>
      <span class="ri-body">₪</span>
    </div>
    <riseup-button class="margin-top-xl continue-btn" title="לייעוץ משכנתא עם רייזאפ" color="green" :action="onMortgageContinueClick" />
    <riseup-button v-if="showNextOptionButton" class="margin-top-sm margin-bottom-s" title="לאפשרות הבאה" color="green" variant="secondary"
     :action="showNextOption" />
  </div>
</bottom-sheet>
</template>

<script>

import BaseUI from '@riseupil/base-ui';
import moneyUtils from '@/utils/money';

export const MORTGAGE_MENU_VARIANTS = {
  MONTHLY_SAVING: 'MONTHLY_SAVING',
  TOTAL_SAVING: 'TOTAL_SAVING',
};

export default {
  name: 'MortgageMenu',
  components: {
    BottomSheet: BaseUI.BottomSheet,
    Separator: BaseUI.Separator,
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    variant: { type: String },
    alternativeTotals: { type: Object },
    currentMortgageTotals: { type: Object },
    showNextOptionButton: { type: Boolean },
  },
  computed: {
    allVariantsValues() {
      return {
        [MORTGAGE_MENU_VARIANTS.MONTHLY_SAVING]: {
          title: 'אפשר לצמצם את ההחזר החודשי שלך בכ-',
          mainDiscount: moneyUtils.signedFormatAmountWithFraction(this.alternativeTotals.monthlyDiff, 0),
          secondaryTitle: 'הוזלת ההחזר החודשי:',
          currentInterestPayments: moneyUtils.signedFormatAmountWithFraction(this.currentMortgageTotals.monthlyPayment, 0),
          currentInterestText: 'ההחזר הממוצע היום',
          alternativeInterestText: 'אחרי שנמחזר ההחזר יהיה בסביבות',
          discountText: 'חסכון שלך כל חודש',
          alternativeInterestPayment: moneyUtils.signedFormatAmountWithFraction(this.alternativeTotals.monthlyPayment, 0),
        },
        [MORTGAGE_MENU_VARIANTS.TOTAL_SAVING]: {
          title: 'אפשר לחסוך על המשכנתא שלך כ-',
          mainDiscount: moneyUtils.signedFormatAmountWithFraction(this.alternativeTotals.totalDiff, 0),
          secondaryTitle: 'חסכון בעלות הכוללת:',
          currentInterestPayments: moneyUtils.signedFormatAmountWithFraction(this.currentMortgageTotals.interestPayments, 0),
          currentInterestText: 'סכום הריביות על המשכנתא הנוכחית',
          alternativeInterestText: 'סכום הריביות אם נמחזר את המשכנתא',
          discountText: 'חסכון שלך סך הכל',
          alternativeInterestPayment: moneyUtils.signedFormatAmountWithFraction(this.alternativeTotals.interestPayments),
        },
      };
    },
    selectedVariantValues() {
      return this.allVariantsValues[this.variant];
    },
  },
  methods: {
    onMortgageContinueClick() {
      this.$emit('continue');
    },
    showNextOption() {
      this.$emit('next');
    },
    closeMenu() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";

.main-discount{
  color: $riseup_green;
}

.amount {
  font-size: 24px;
}

.close-btn {
  margin-top: -12px;
  cursor: pointer;
}

</style>
